import {
  Box,
  Button,
  Grid,
  HStack,
  Icon,
  IconButton,
  Input,
} from '@chakra-ui/react'
import { Trash, Upload } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { ArrayPath, FieldValues, UseFieldArrayReturn } from 'react-hook-form'

import { ImageContainer } from '../../displayers/ImageContainer'

interface MyProps<T extends FieldValues, K extends ArrayPath<T>> {
  fieldArray: UseFieldArrayReturn<T, K>
}

const ImageFileHandler = ({
  data,
  onRemove,
}: {
  data: any
  onRemove: () => void
}) => {
  const [imgStr, setImgStr] = useState<string | null>()

  useEffect(() => {
    try {
      const reader = new FileReader()
      reader.onloadend = () => setImgStr(reader.result?.toString())
      reader.readAsDataURL(data[0])
    } catch (error: any) {
      console.error(error.message)
    }
  }, [data])

  return (
    <Box position="relative">
      <ImageContainer src={imgStr ?? undefined} size="sm" />
      <Box position="absolute" top={2} right={2}>
        <IconButton
          size="xs"
          aria-label="Remover"
          icon={<Icon as={Trash} />}
          colorScheme="primary"
          onClick={onRemove}
        />
      </Box>
    </Box>
  )
}

export default function <T extends FieldValues, K extends ArrayPath<T>>({
  fieldArray,
}: MyProps<T, K>) {
  const inputImageRef = useRef<HTMLInputElement>(null)
  const { fields, append, remove } = fieldArray

  const onAddImage = () => {
    inputImageRef.current?.click()
  }

  const handleAddImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      append(e.target.files as any)
    }
  }

  return (
    <Box>
      <Grid overflow="hidden" mb={2}>
        <HStack overflowX="auto" pb={2}>
          {fields.length === 0 && (
            <Box fontSize="xs" color="gray.400">
              Galeria vazia
            </Box>
          )}
          {fields.map((field, index) => {
            return (
              <ImageFileHandler
                key={field.id}
                data={field}
                onRemove={() => remove(index)}
              />
            )
          })}
        </HStack>
      </Grid>

      <Input
        ref={inputImageRef}
        display="none"
        type="file"
        accept="image/*"
        onChange={handleAddImage}
      />
      <Button
        onClick={onAddImage}
        leftIcon={<Icon as={Upload} />}
        colorScheme="primary"
      >
        Enviar imagem
      </Button>
    </Box>
  )
}
